module.exports = __webpack_public_path__ + "static/img/teach_plat.08e93ed3.png";